import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";
import store from "./store/store";

const config = require("./config.js");

export default {
  init() {
    firebase.initializeApp(config.firebaseConfig);
  },

  async createUser(email, password) {
    const user = firebase.auth().currentUser;
    if (user == null) {
      // create new user
      await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(async (userCredential) => {
          if (store.state.registrationData) {
            if (userCredential.user.uid !== store.state.registrationData.uid) {
              // 新しいuidで登録しなおした場合
              await this.duplicateRegistration(userCredential.user.uid);
            } else {
              await this.updateRegistration(userCredential.user.uid);
            }
            await this.login(email, password);
          } else {
            await this.createRegistraion(userCredential.user.uid);
          }
      })
      .catch((error) => {
        throw error;
      });
    }
    else if (user.isAnonymous) {
      // create new auth method then link to exist account
      var credential = firebase.auth.EmailAuthProvider.credential(email, password);
      firebase.auth().currentUser.linkWithCredential(credential)
        .then(async (usercred) => {
          var user = usercred.user;
          await this.updateRegistration(usercred.user.uid);
          await this.getRegistraion();
          store.commit("setIsLoggedInWithFirebaseAuth", true);
        }).catch((error) => {
          console.log("Error upgrading anonymous account", error);
        });
    }
    else {
      console.log("invald account state", user);
    }
    
  },

  async deleteAccount(password) {
    const email = await this.onAuthStateChanged();

    let tmpUserCredential = "";
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (userCredential) => {
        tmpUserCredential = userCredential;
      })
      .catch((error) => {
        throw error;
      });

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .update({
        deleted: true,
        UpdatedAt: this.getNow(),
      });

    const user = firebase.auth().currentUser;
    await user
      .delete()
      .then(() => {})
      .catch((error) => {
        throw error;
      });

    localStorage.removeItem("id");
  },

  async updateRegistration(uid) {
    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationData.id)
      .update({
        uid: uid,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        store.commit("setRegistraionData", {
          uid: uid,
          ...store.state.registrationData,
        });
      });
  },

  async duplicateRegistration(uid) {
    await firebase
      .firestore()
      .collection("registrations")
      .add(store.state.registrationData)
      .then(() => {
        store.commit("setRegistraionData", {
          uid: uid,
          ...store.state.registrationData,
        });
      });
  },

  async login(email, password) {
    let tmpUserCredential = "";
    await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (userCredential) => {
        tmpUserCredential = userCredential;
      });

    // uid相違なら登録情報を取得してくる
    if (
      store.state.registrationData === undefined ||
      tmpUserCredential.user.uid !== store.state.registrationData.uid
    ) {
      await firebase
        .firestore()
        .collection("registrations")
        .where("uid", "==", tmpUserCredential.user.uid)
        .get()
        .then((snapshot) => {
          if (snapshot.empty) {
            // throw error;
            // このルートに入るのは『新規登録をやり直した』ユーザーデータ
            //
          } else {
            snapshot.forEach(async (doc) => {
              if (doc.data().deleted) return;
              store.commit("setRegistraionData", doc.data());
              store.commit("setRegistrationId", doc.id);
            });
          }
        })
        .catch((err) => {
          alert(
            "ログイン情報取得中にエラーが発生しました。管理者にご連絡ください。",
            err,
          );
        });
      if (tmpUserCredential.user.uid !== store.state.registrationData.uid) {
        await this.updateRegistration(tmpUserCredential.user.uid);
      }

      await this.getRegistraion();
    } else {
      // uid一致ならそのまま
      store.commit("setRegistraionData", {
        uid: tmpUserCredential.user.uid,
        ...store.state.registrationData,
      });
    }
  },

  async sendOubo(payload) {
    const now = this.getNow();

    var point = store.state.registrationData.Point;
    if (point < 100) {
      return;
    }

    const ref = firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationData.id)
      .collection("answers");
    await ref.add(this.createAnsDoc("景品応募", payload.name, now));
    await ref.add(
      this.createAnsDoc("メールアドレス", payload.mailAddress, now),
    );

    point = point - 100;

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .update({
        Point: point,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        store.commit("setRegistraionData", {
          ...store.state.registrationData,
          Point: point,
        });
      });
  },

  async logout() {
    return new Promise((resolve) => {
      localStorage.removeItem("id");
      firebase
        .auth()
        .signOut()
        .then(() => {
          store.commit("setIsLoggedInWithFirebaseAuth", false);
          store.commit("setRegistraionData", undefined);
          store.commit("setRegistrationId", undefined);
          store.commit("setMissions", []);
          store.commit("setCheckinList", []);
          store.commit("setImageReputationList", []);
          store.commit("setAnswers", undefined);
          resolve();
        })
        .catch(() => {});
    });
  },

  async onAuthStateChanged() {
    return new Promise((resolve) => {
      const user = firebase.auth().currentUser;
      let email = "";
      if (user) {
        store.commit("setIsLoggedInWithFirebaseAuth", !user.isAnonymous);
        email = user.email;
        resolve(email);
      } else {
        firebase.auth().onAuthStateChanged(async (user) => {
          if (user) {
            store.commit("setIsLoggedInWithFirebaseAuth", !user.isAnonymous);
            email = user.email;
            resolve(email);
          } else {
            store.commit("setIsLoggedInWithFirebaseAuth", false);
            resolve(email);
          }
        });
      }
    });
  },

  async getIsLoggednInWithFirebaseAuth() {
    await this.onAuthStateChanged();
    const user = firebase.auth().currentUser;

    if (store.state.isLoggedInWithFirebaseAuth) {
      await firebase
        .firestore()
        .collection("registrations")
        .where("uid", "==", user.uid)
        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            snapshot.forEach((doc) => {
              if (doc.data().deleted) return;
              store.commit("setRegistraionData", {
                id: doc.id,
                ...doc.data(),
                email: user.email,
              });
              localStorage.setItem("id", doc.id);
            });
          }
        });
    }
  },

  async sendPasswordResetEmail(email) {
    const result = firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {})
      .catch((error) => {
        throw error.code;
      });
    return result;
  },

  padZero(num) {
    var result;
    if (num < 10) {
      result = "0" + num;
    } else {
      result = "" + num;
    }
    return result;
  },

  getNow() {
    var now = new Date();
    var res =
      "" +
      now.getFullYear() +
      "-" +
      this.padZero(now.getMonth() + 1) +
      "-" +
      this.padZero(now.getDate()) +
      " " +
      this.padZero(now.getHours()) +
      ":" +
      this.padZero(now.getMinutes()) +
      ":" +
      this.padZero(now.getSeconds());
    return res;
  },

  convertStartTime(parsedString) {
    var now = new Date();
    var res =
      "" +
      now.getFullYear() +
      "-" +
      this.padZero(now.getMonth() + 1) +
      "-" +
      this.padZero(now.getDate()) +
      " " +
      parsedString[0] +
      ":" +
      parsedString[1] +
      ":" +
      this.padZero(now.getSeconds());
    return res;
  },

  convertTime(now) {
    var res =
      "" +
      now.getFullYear() +
      "-" +
      this.padZero(now.getMonth() + 1) +
      "-" +
      this.padZero(now.getDate()) +
      " " +
      this.padZero(now.getHours()) +
      ":" +
      this.padZero(now.getMinutes()) +
      ":" +
      this.padZero(now.getSeconds());
    return res;
  },
  getStartTime() {
    const time = new RegExp("([0-9]{2})", "g");
    let parsedString = this.getCurrentSearch().departureTime.match(time);
    var now = new Date();
    var res =
      "" +
      now.getFullYear() +
      "-" +
      this.padZero(now.getMonth() + 1) +
      "-" +
      this.padZero(now.getDate()) +
      " " +
      parsedString[0] +
      ":" +
      parsedString[1] +
      ":" +
      this.padZero(now.getSeconds());
    return res;
  },
  calcTime(value) {
    var now = new Date();
    const time = new RegExp("([0-9]{2})", "g");
    let parsedString = this.getCurrentSearch().departureTime.match(time);
    this.convertStartTime(parsedString);
    var dt = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      parsedString[0],
      parsedString[1],
      now.getMinutes(),
    );
    dt.setSeconds(dt.getSeconds() + value);
    return {
      start: this.convertStartTime(parsedString),
      end: this.convertTime(dt),
    };
  },
  mappingSpotTypeText() {
    if (store.state.selectedSpotType === "食事") return "restaurant";
    else if (store.state.selectedSpotType === "お土産") return "shop";
    else if (store.state.selectedSpotType === "観光") return "sight";
    else if (store.state.selectedSpotType === "温泉") return "leisure";
    else if (store.state.selectedSpotType === "体験") return "leisure";
  },
  mappingCaregory2Text(value) {
    if (value === 1) return "restaurant";
    else if (value === 2) return "shop";
    else if (value === 3) return "sight";
    else if (value === 4) return "leisure";
    else if (value === 5) return "leisure";
  },
  async putLog(payload) {
    var now = this.getNow();
    var RelatedJsonData = payload.RelatedJsonData;
    if (!RelatedJsonData) RelatedJsonData = null;
    var ActionParams = payload.ActionParams;
    if (!ActionParams) ActionParams = {};

    const current = store.state.currentPageName;
    let formattedActionType = `${payload.ActionType}`;

    if (current === "RouteSearch" || current == "JyutaiSearch") {
      formattedActionType = `${this.getActionType()}.${payload.ActionType}`;
    }

    await firebase
      .firestore()
      .collection("logs")
      .add({
        ActionType: formattedActionType,
        ActionParams: JSON.stringify({
          ...ActionParams,
        }),
        Lat: store.state.currentLat,
        Lon: store.state.currentLng,
        RelatedJsonData: RelatedJsonData,
        RegistrationAutoId: store.state.registrationId,
        CreatedAt: now,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      });
  },

  async createRegistraion(uid='') {
    const user = firebase.auth().currentUser;

    if (user == null && uid == '') {
      await firebase.auth().signOut();
      await firebase.auth().signInAnonymously();
      uid = firebase.auth().currentUser.uid;
    }

    const doc = firebase
      .firestore()
      .collection("registrations")
      .doc();

    var now = this.getNow();
    const param = {
      uid: uid,
      Age: 0,
      Agreement: 10,
      Area: "",
      Autoid: doc.id,
      Companion: 1,
      Developer: "1",
      Email: "",
      ExperimentParticipant: -1,
      FcmToken: "",
      FinalQAnswerd: -1,
      FinalQShown: -1,
      FinalRouteShown: -1,
      Gender: -1,
      LocationGettingAccepted: "-1",
      LoggedIn: "",
      MapAppShown: -1,
      Platform: "Web",
      Point: 0,
      TotalPoint: 0,
      WithChildren: -1,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      UpdatedAt: now,
      Rank: 1,
    };

    await doc.set(param).then(() => {
      store.commit("setRegistraionData", {
        ...param,
        id: doc.id,
      });
      store.commit("setRegistrationId", doc.id);
      localStorage.setItem("id", doc.id);
    });
  },
  async putLocation() {
    var now = this.getNow();
    const params = {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      Lat: store.state.currentLat,
      Lon: store.state.currentLng,
      CreatedAt: now,
      UpdatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };
    firebase.firestore().collection("locations").add(params);
  },
  async clearPhotoMisson(payload) {
    var now = this.getNow();
    const param = {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      imagePath: payload.image_path,
      missionId: payload.mission_id,
      missionTitle: payload.mission_title,
      Point: payload.mission_point,
      missionTime: 0,
      spotId: payload.spot_id,
      Lat: store.state.currentLat,
      Lon: store.state.currentLng,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("missions")
      .add(param)
      .then(() => {
        store.commit("setMissions", [...store.state.missions, param]);
      });

    const sumPoint = store.state.registrationData.Point + Number(payload.mission_point);
    const totalPoint = store.state.registrationData.TotalPoint + Number(payload.mission_point);
    const rank = Math.trunc(totalPoint / 100) + 1;

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .update({
        Point: sumPoint,
        TotalPoint: totalPoint,
        Rank: rank,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        store.commit("setRegistraionData", {
          ...store.state.registrationData,
          Point: sumPoint,
          TotalPoint: totalPoint,
        });
      });
  },
  async getQuizItemClearStatus(missionId) {
    let returnData = [];
    let quizItemIds = [];

    const collectionRef = firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("missions");

    await collectionRef
      .where("missionId", "==", missionId)
      .get()
      .then((snapshot) => {
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            quizItemIds.push({
              id: doc.id,
              ...doc.data(),
            });
          });
        }
      });

    for (const doc of quizItemIds) {
      const quizItemsSnapshot = await collectionRef
        .doc(doc.id)
        .collection("quiz_items")
        .get();

      if (!quizItemsSnapshot.empty) {
        quizItemsSnapshot.forEach((doc) => {
          returnData.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      }
    }

    return returnData;
  },
  async clearQuizMission(payload) {
    var now = this.getNow();
    const param = {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      missionId: payload.mission_id,
      missionTitle: payload.mission_title,
      imagePath: '',
      Point: payload.mission_point,
      missionTime: 0,
      spotId: payload.spot_id,
      Lat: store.state.currentLat,
      Lon: store.state.currentLng,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    let missionsId = "";

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("missions")
      .add(param)
      .then((ref) => {
        missionsId = ref.id;
        store.commit("setMissions", [...store.state.missions, param]);
      });

    const quizItemParam = {
      quiz_item_id: payload.quiz_item_id,
      Point: payload.mission_point,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("missions")
      .doc(missionsId)
      .collection("quiz_items")
      .add(quizItemParam);

    const sumPoint =store.state.registrationData.Point + Number(payload.mission_point);
    const totalPoint = store.state.registrationData.TotalPoint + Number(payload.mission_point);
    const rank = Math.trunc(totalPoint / 100) + 1;

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .update({
        Point: sumPoint,
        TotalPoint: totalPoint,
        Rank: rank,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        store.commit("setRegistraionData", {
          ...store.state.registrationData,
          Point: sumPoint,
          TotalPoint: totalPoint,
        });
      });
  },
  async checkin(payload) {
    var now = this.getNow();
    const param = {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      spotId: payload.spotId,
      spotName: payload.name,
      Lat: store.state.currentLat,
      Lon: store.state.currentLng,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    // チェックインは一律10ポイント
    const sumPoint = store.state.registrationData.Point + 10;
    const totalPoint = store.state.registrationData.TotalPoint + 10;
    const rank = Math.trunc(totalPoint / 100) + 1;

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("checkins")
      .add(param)
      .then(() => {
        store.commit("setCheckinList", [...store.state.checkinList, param]);
      });

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .update({
        Point: sumPoint,
        TotalPoint: totalPoint,
        Rank: rank,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        store.commit("setRegistraionData", {
          ...store.state.registrationData,
          Point: sumPoint,
          TotalPoint: totalPoint,
        });
      });

    await firebase
      .firestore()
      .collection("spots")
      .doc(payload.spotId.toString())
      .update({
        CheckIn: payload.checkin + 1,
        UpdatedAt: this.getNow(),
      })
      .then(() => {
        const tmp = this.getCurrentSelectSpot();
        tmp.CheckIn = payload.checkin + 1;
        store.commit("setSelectedSpotData", tmp);
      });
  },
  getActionType(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return "SightSeeing";
    } else if (current === "JyutaiSearch") {
      return "JamPrediction";
    }
  },
  getCurrentSelectSpot(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.selectedSpotData.dropspot;
    } else if (current === "MyPage") {
      return store.state.selectedSpotData.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.selectedSpotData.jyutai;
    }
  },
  getCurrentComments(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.selectedSpotCommentData.dropspot;
    } else if (current === "MyPage") {
      return store.state.selectedSpotCommentData.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.selectedSpotCommentData.jyutai;
    }
  },
  getCurrentTickets(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.selectedSpotTicketData.dropspot;
    } else if (current === "MyPage") {
      return store.state.selectedSpotTicketData.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.selectedSpotTicketData.jyutai;
    }
  },
  getCurrentDepLatLng(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.DepLatLng.dropspot;
    } else if (current === "MyPage") {
      return store.state.DepLatLng.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.DepLatLng.jyutai;
    }
  },
  getCurrentDesLatLng(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.DesLatLng.dropspot;
    } else if (current === "MyPage") {
      return store.state.DesLatLng.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.DesLatLng.jyutai;
    }
  },
  getCurrentSearch(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.search.dropspot;
    } else if (current === "MyPage") {
      return store.state.search.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.search.jyutai;
    }
  },
  getCurrentDropDestionaton(value) {
    const current = value ? value : store.state.currentPageName;
    if (current === "RouteSearch") {
      return store.state.dropDestionaton.dropspot;
    } else if (current === "MyPage") {
      return store.state.dropDestionaton.mypage;
    } else if (current === "JyutaiSearch") {
      return store.state.dropDestionaton.jyutai;
    }
  },
  async commitReputation(payload) {
    var now = this.getNow();
    const spotData = this.getCurrentSelectSpot();

    const ref = firebase
      .firestore()
      .collection("spots")
      .doc(spotData.id.toString())
      .collection("comments")
      .doc();

    const param = {
      Id: ref.id,
      ServicePlaceId: spotData.service_place_id,
      SpotId: spotData.id,
      Content: payload.content,
      Reputation: payload.reputation,
      RegistrationAutoId: store.state.registrationId,
      CreatedAt: now,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    const tmp = [param, ...this.getCurrentComments()];

    await ref.set(param).then(() => {
      store.commit("setSelectedSpotCommentData", tmp);
    });

    return tmp;
  },
  async addImage(payload) {
    // yyyymmddhhmmss
    const time = new Date().getTime();
    const imagePath = `spots/${payload.spot_id}/missions/${payload.mission_id}/${store.state.registrationData.uid}_${time}`;

    return new Promise((resolve) => {
      var imgRef = firebase.storage().ref().child(imagePath);
      imgRef.put(payload.file).then(function (snapshot) {
        resolve(imagePath);
      });
    });
  },
  async getRegistraion() {
    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          // no such document
        } else {
          if (doc.data().deleted) return;
          store.commit("setRegistraionData", {
            ...doc.data(),
            id: doc.id,
          });
        }
      });

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("missions")
      .orderBy("CreatedAt", "desc")
      .get()
      .then((snapshot) => {
        const missions = [];
        snapshot.forEach((doc) => missions.push(doc.data()));
        store.commit("setMissions", missions);
      });

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("checkins")
      .orderBy("CreatedAt", "desc")
      .get()
      .then((snapshot) => {
        const checkins = [];
        snapshot.forEach((doc) => checkins.push(doc.data()));
        store.commit("setCheckinList", checkins);
      });

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("image_reputations")
      .orderBy("CreatedAt", "asc")
      .get()
      .then((snapshot) => {
        const reputations = [];
        snapshot.forEach((doc) => reputations.push(doc.data()));
        store.commit("setImageReputationList", reputations);
      });

    await this.getAnswers();
  },
  async getImage(imageUrl) {
    let returnData = {
      Reputation: 0,
    };
    await firebase
      .firestore()
      .collection("Images")
      .where("ImagePath", "==", imageUrl)
      .get()
      .then((snapshot) => {
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            returnData = {
              id: doc.id,
              ...doc.data(),
            };
          });
        }
      });
    return returnData;
  },
  async getImageUrl(imagePath) {
    var imgRef = firebase.storage().ref(imagePath);
    return imgRef.getDownloadURL();
  },
  async updateImageReputation(spotData, missionData, imageUrl) {
    var reputation = 1;
    var imageSnapshot = await firebase
      .firestore()
      .collection("Images")
      .where("MissionId", "==", missionData.mission_id)
      .where("ImagePath", "==", imageUrl)
      .get();

    if (imageSnapshot.empty) {
      const imageDocRef = firebase.firestore().collection("Images").doc();        
      const imagesParam = {
        Id: imageDocRef.id,
        ServicePlaceId: spotData.service_place_id,
        SpotId: spotData.id,
        MissionId: missionData.mission_id,
        Reputation: 1,
        ImagePath: imageUrl,
      };
      await imageDocRef.set(imagesParam);
    }
    else {
      const doc = imageSnapshot.docs[imageSnapshot.docs.length - 1];
      reputation = doc.data().Reputation + 1;
      await firebase
        .firestore()
        .collection('Images')
        .doc(doc.id)
        .update({'Reputation': firebase.firestore.FieldValue.increment(1)});
    }

    const reputationParams = {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      spotId: spotData.id,
      missionId: missionData.mission_id,
      imagePath: imageUrl,
      lat: store.state.currentLat,
      lon: store.state.currentLng,
      CreatedAt: this.getNow(),
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };
    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("image_reputations")
      .add(reputationParams)
      .then(() => {
        store.commit("setImageReputationList", [
          ...store.state.imageReputationList,
          reputationParams,
        ]);
      });

    return reputation;
  },
  async deleteImageReputation(spotData, missionData, imageUrl) {
    var reputation = 0;
    var imageSnapshot = await firebase
      .firestore()
      .collection("Images")
      .where("MissionId", "==", missionData.mission_id)
      .where("ImagePath", "==", imageUrl)
      .get();

    if (!imageSnapshot.empty) {
      const doc = imageSnapshot.docs[imageSnapshot.docs.length - 1];
      reputation = doc.data().Reputation - 1;
      await firebase
        .firestore()
        .collection('Images')
        .doc(doc.id)
        .update({'Reputation': firebase.firestore.FieldValue.increment(-1)});
    }

    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("image_reputations")
      .where("imagePath", "==", imageUrl)
      .get()
      .then((snapshot) => {
        snapshot.forEach(async (doc) => {
          await firebase
            .firestore()
            .collection("registrations")
            .doc(store.state.registrationId)
            .collection("image_reputations")
            .doc(doc.id)
            .delete();
        });
        store.commit(
          "setImageReputationList",
          store.state.imageReputationList.filter(
            (item) => item.imagePath !== imageUrl,
          ),
        );
      });

    return reputation;
  },
  mappingAnswerId(doc) {
    const ques = doc.data().Question;

    if (ques === "宿泊・日帰り") return "syukuhaku";
    if (ques === "帰宅予定時間") return "kitaku";
    if (ques === "同伴者（自分を除く）") return "fellowNumber";
    if (ques === "同伴者の構成") return "fellow";
    if (ques === "山梨県への訪問回数") return "yamanashiVistNumber";
  },
  async getAnswers() {
    await firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationId)
      .collection("answers")
      .get()
      .then((snapshot) => {
        let answers = {};
        let answerLastDate = {};
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            if (doc.data().Question === "性別") {
              store.commit("setRegistraionData", {
                ...store.state.registrationData,
                userSettingDone: true,
              });
            }
            if (doc.data().Question === "宿泊・日帰り") {
              if (
                store.state.registrationData.lastReasearchAnswer === undefined
              ) {
                store.commit("setRegistraionData", {
                  ...store.state.registrationData,
                  lastReasearchAnswer: doc.data().CreatedAt,
                });
                answers.syukuhaku = doc.data().Content;
              } else if (
                store.state.registrationData.lastReasearchAnswer <
                doc.data().CreatedAt
              ) {
                store.commit("setRegistraionData", {
                  ...store.state.registrationData,
                  lastReasearchAnswer: doc.data().CreatedAt,
                });
                answers.syukuhaku = doc.data().Content;
              }
            }
            if (doc.data().Question === "帰宅予定時間") {
              if (answerLastDate.kitaku === undefined) {
                answers.kitaku = doc.data().Content;
                answerLastDate.kitaku = doc.data().CreatedAt;
              } else if (answerLastDate.kitaku < doc.data().CreatedAt) {
                answers.kitaku = doc.data().Content;
                answerLastDate.kitaku = doc.data().CreatedAt;
              }
            }
            if (doc.data().Question === "同伴者（自分を除く）") {
              if (answerLastDate.fellowNumber === undefined) {
                answers.fellowNumber = doc.data().Content;
                answerLastDate.fellowNumber = doc.data().CreatedAt;
              } else if (answerLastDate.fellowNumber < doc.data().CreatedAt) {
                answers.fellowNumber = doc.data().Content;
                answerLastDate.fellowNumber = doc.data().CreatedAt;
              }
            }
            if (doc.data().Question === "同伴者の構成") {
              if (answerLastDate.fellow === undefined) {
                answers.fellow = doc.data().Content;
                answerLastDate.fellow = doc.data().CreatedAt;
              } else if (answerLastDate.fellow < doc.data().CreatedAt) {
                answers.fellow = doc.data().Content;
                answerLastDate.fellow = doc.data().CreatedAt;
              }
            }
            if (doc.data().Question === "山梨県への訪問回数") {
              if (answerLastDate.yamanashiVistNumber === undefined) {
                answers.yamanashiVistNumber = doc.data().Content;
                answerLastDate.yamanashiVistNumber = doc.data().CreatedAt;
              } else if (
                answerLastDate.yamanashiVistNumber < doc.data().CreatedAt
              ) {
                answers.yamanashiVistNumber = doc.data().Content;
                answerLastDate.yamanashiVistNumber = doc.data().CreatedAt;
              }
            }
          });
        }
        store.commit("setAnswers", answers);
      });
  },
  async getSpot(current) {
    // 独自APIのIDで検索,oriApiId
    const spot = this.getCurrentSelectSpot(current);
    const now = this.getNow();
    let noSpot = false;

    await firebase
      .firestore()
      .collection("spots")
      .doc(spot.id.toString())
      .get()
      .then((doc) => {
        if (!doc.exists) {
          noSpot = true;
          store.commit("setSelectedSpotCommentData", []);
          store.commit("setSelectedSpotTicketData", []);
        } else {
          store.commit("setSelectedSpotData", {
            ...this.getCurrentSelectSpot(),
            CheckIn: doc.data().CheckIn ? doc.data().CheckIn : 0,
          });
          doc.data()
        }
      })
      .catch((error, stacktrace) => {
        alert(
          "場所情報取得中にエラーが発生しました。管理者にご連絡ください。",
          error,
        );
      });

    if (noSpot) {
      const doc = firebase.firestore()
        .collection("spots")
        .doc(spot.id.toString());
      await doc
        .set({
          Id: spot.id.toString(),
          ServicePlaceId: spot.service_place_id,
          SpotId: spot.id,
          CheckIn: 0,
          CreatedAt: now,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          store.commit("setSelectedSpotData", {
            ...this.getCurrentSelectSpot(),
            CheckIn: 0,
          });
        });
    } else {
      await firebase
        .firestore()
        .collection("spots")
        .doc(spot.id.toString())
        .collection("comments")
        .orderBy("timestamp", "desc")
        .get()
        .then((snapshotInner) => {
          if (snapshotInner.empty) {
            store.commit("setSelectedSpotCommentData", []);
          } else {
            const data = [];
            snapshotInner.forEach((doc) => {
              data.push(doc.data());
            });
            store.commit("setSelectedSpotCommentData", data);
          }
        });

      await firebase
        .firestore()
        .collection("spots")
        .doc(spot.id.toString())
        .collection("tickets")
        .get()
        .then((snapshotInner) => {
          if (snapshotInner.empty) {
            store.commit("setSelectedSpotTicketData", []);
          } else {
            const data = [];
            snapshotInner.forEach((doc) => {
              data.push(doc.data());
            });
            store.commit("setSelectedSpotTicketData", data);
          }
        });
    }
  },
  async useTicket(id) {
    const spot = this.getCurrentSelectSpot();

    const param = {
      ServicePlaceId: this.mappingUndefinedToNull(spot.service_place_id),
      SpotId: spot.id,
      TicketId: id,
      Use: true,
      RegistrationAutoId: store.state.registrationId,
      CreatedAt: this.getNow(),
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    };

    await firebase
      .firestore()
      .collection("spots")
      .doc(spot.id.toString())
      .collection("tickets")
      .add(param);

    store.commit("setSelectedSpotTicketData", [
      ...this.getCurrentTickets(),
      param,
    ]);
  },
  async getSpotById(spotId, service_place_id) {
    var now = this.getNow();
    let returnSpotData = undefined;

    await firebase
      .firestore()
      .collection("spots")
      .doc(spotId.toString())
      .get()
      .then(async (doc) => {
        if (!doc.exists) {
          await firebase
            .firestore()
            .collection("spots")
            .doc(spotId.toString())
            .set({
              Id: spotId.toString(),
              ServicePlaceId: service_place_id,
              SpotId: spotId,
              CheckIn: 0,
              CreatedAt: now,
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(() => {
              returnSpotData = {
                ...this.getCurrentSelectSpot(),
                CheckIn: 0,
              };
            });
        } else {
          returnSpotData = {
            ...this.getCurrentSelectSpot(),
            CheckIn: doc.data().CheckIn,
          };
        }
      })
      .catch((err) => {
        alert(
          "場所情報取得中にエラーが発生しました。管理者にご連絡ください。",
          err,
        );
      });

    return returnSpotData;
  },
  mappingUndefinedToNull(value) {
    if (value === undefined) {
      return null;
    }
    return value;
  },
  createAnsDoc(question, content, now) {
    return {
      RegistrationAutoId: store.state.registrationId,
      uid: this.mappingUndefinedToNull(store.state.registrationData.uid),
      Question: question,
      Content: content,
      CreatedAt: now,
      UpdatedAt: now,
    };
  },
  formatGender(value) {
    if (value === "男性") return 10;
    else if (value === "女性") return 20;
    else if (value === "その他") return 0;
    return -1;
  },
  formatAge(value) {
    if (value === "10代") return 10;
    else if (value === "20代") return 20;
    else if (value === "30代") return 30;
    else if (value === "40代") return 40;
    else if (value === "50代") return 50;
    else if (value === "60代") return 60;
    else if (value === "70代以上") return 70;
    return -1;
  },
  async putUserSettings(ans) {
    var now = this.getNow();
    const ref = firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationData.id)
      .collection("answers");
    await ref.add(this.createAnsDoc("性別", ans.gender, now));
    await ref.add(this.createAnsDoc("年代", ans.age, now));
    await ref.add(this.createAnsDoc("居住都道府県", ans.pref, now));

    store.commit("setRegistraionData", {
      ...store.state.registrationData,
      userSettingDone: true,
    });
  },
  async putUserResearch(ans) {
    var now = this.getNow();
    let ref = firebase
      .firestore()
      .collection("registrations")
      .doc(store.state.registrationData.id)
      .collection("answers");
    await ref.add(this.createAnsDoc("宿泊・日帰り", ans.syukuhaku, now));
    await ref.add(this.createAnsDoc("帰宅予定時間", ans.kitaku, now));
    await ref.add(
      this.createAnsDoc("同伴者（自分を除く）", ans.fellowNumber, now),
    );
    await ref.add(this.createAnsDoc("同伴者の構成", ans.fellow, now));
    await ref.add(
      this.createAnsDoc("山梨県への訪問回数", ans.yamanashiVistNumber, now),
    );

    store.commit("setRegistraionData", {
      lastReasearchAnswer: now,
      ...store.state.registrationData,
    });
  },
};



// WEBPACK FOOTER //
// ./src/firebase.js